var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleMaps({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "googleMaps",
    transform: "translate(334 -2447)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_436",
    "data-name": "Rectangle 436",
    width: 150,
    height: 150,
    transform: "translate(-334 2447)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g19",
    transform: "translate(-302.71 2459.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g842",
    transform: "translate(0.035 -0.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path835",
    d: "M797.6,225.735a122.243,122.243,0,0,1,9.9,14.614c2.522,4.785,3.558,8.016,5.438,13.781,1.1,3.175,2.139,4.143,4.335,4.143,2.4,0,3.49-1.621,4.335-4.143,1.745-5.438,3.107-9.57,5.235-13.522,4.2-7.566,9.514-14.3,14.682-20.761,1.419-1.813,10.482-12.486,14.558-20.953a51.1,51.1,0,0,0,4.976-22.191,44.079,44.079,0,0,0-4.92-20.5L841.9,160.017l-8.669,22.765L831.1,185.89l-.45.585-.585.709-.968,1.16-1.419,1.419-7.7,6.271-19.208,11.124Z",
    transform: "translate(-773.901 -133.273)",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path833",
    d: "M621.2,272.326c4.717,10.741,13.713,20.12,19.861,28.395l32.538-38.55a17.081,17.081,0,0,1-12.869,6.012A16.657,16.657,0,0,1,643.977,251.5a17.816,17.816,0,0,1,3.817-10.8l-22.067,5.888Z",
    transform: "translate(-616.933 -207.954)",
    fill: "#fbbc04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path831",
    d: "M883.5-35.1a43.4,43.4,0,0,1,25.614,21.606L883.105,17.49a18.059,18.059,0,0,0,3.817-10.8A16.843,16.843,0,0,0,870.236-9.993,17.5,17.5,0,0,0,857.3-4.037V-23.582Z",
    transform: "translate(-826.88 37.104)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path829",
    d: "M674-37.25A43.44,43.44,0,0,1,707.439-52.9a44.694,44.694,0,0,1,13.319,2L694.637-19.844h-18.5Z",
    transform: "translate(-663.788 52.9)",
    fill: "#1a73e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path827",
    d: "M587.567,135.665a50.106,50.106,0,0,1-4.267-20.694A43.59,43.59,0,0,1,593.579,86.7l20.638,17.395Z",
    transform: "translate(-583.3 -70.983)",
    fill: "#ea4335"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMaps);
export default __webpack_public_path__ + "static/media/googleMaps.4b3ebeca531f40a9798bfce0a4327bca.svg";
export { ForwardRef as ReactComponent };